import React, { useEffect, useState } from 'react';
import { Form, Input, Select, DatePicker, Button, message, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { applyLeave } from '../redux/slices/leaveSlice';
import { fetchOrgLeaveTypes } from '../redux/slices/leaveTypeSlice';
import leaveTypeService from '../services/leaveTypeService';
import moment from 'moment';

const LeaveForm = ({ onSuccess }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { isLoading } = useSelector(state => state.leaves);
  const { orgList: leaveTypes } = useSelector(state => state.leaveTypes);
  const [leaveTypesLoading, setLeaveTypesLoading] = useState(false);

  useEffect(() => {
    loadLeaveTypes();
  }, []);

  const loadLeaveTypes = async () => {
    try {
      setLeaveTypesLoading(true);
      await dispatch(fetchOrgLeaveTypes()).unwrap();
    } catch (error) {
      console.error('Error loading leave types:', error);
      message.error('Failed to load leave types');
    } finally {
      setLeaveTypesLoading(false);
    }
  };

  const onFinish = async (values) => {
    try {
      const leaveData = {
        leaveTypeId: values.leaveType,
        startDate: values.dateRange[0].format('YYYY-MM-DD'),
        endDate: values.dateRange[1].format('YYYY-MM-DD'),
        reason: values.reason
      };

      await dispatch(applyLeave(leaveData)).unwrap();
      message.success('Leave request submitted successfully');
      form.resetFields();
      if (onSuccess) onSuccess();
    } catch (error) {
      message.error(error || 'Failed to apply leave');
    }
  };

  const leaveTypeOptions = leaveTypes.map(lt => ({
    label: `${lt.name} (${lt.defaultDays} days)`,
    value: lt.id
  }));

  return (
    <Spin spinning={isLoading || leaveTypesLoading}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
      >
        <Form.Item
          label="Leave Type"
          name="leaveType"
          rules={[{ required: true, message: 'Please select leave type' }]}
        >
          <Select
            placeholder="Select leave type"
            options={leaveTypeOptions}
            loading={leaveTypesLoading}
          />
        </Form.Item>

        <Form.Item
          label="Date Range"
          name="dateRange"
          rules={[{ required: true, message: 'Please select date range' }]}
        >
          <DatePicker.RangePicker
            format="YYYY-MM-DD"
            disabledDate={(current) => current && current < moment().startOf('day')}
          />
        </Form.Item>

        <Form.Item
          label="Reason"
          name="reason"
          rules={[{ required: true, message: 'Please enter reason' }]}
        >
          <Input.TextArea
            rows={4}
            placeholder="Enter reason for leave"
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            block
            loading={isLoading}
          >
            Submit Leave Request
          </Button>
        </Form.Item>
      </Form>
    </Spin>
  );
};

export default LeaveForm;
